import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { stockListsApi } from '@/api';
import { saveBlobResponse } from '@/api/utils/download';
import type { StockListFormat } from './stock-lists.service';

interface DownloadStockListVars {
  businessPartnerId: number;
  format: StockListFormat;
}

/**
 * Downloads the customer Bestandsliste through the authenticated axios
 * instance and saves it via the shared blob-download helper. Replaces the
 * old plain `<a href>` link, which sent no bearer token and so always 401'd.
 */
export const useDownloadStockList = (
  options?: UseMutationOptions<void, AxiosError, DownloadStockListVars>,
) =>
  useMutation<void, AxiosError, DownloadStockListVars>({
    mutationFn: async ({ businessPartnerId, format }) => {
      const response = await stockListsApi.downloadStockList(
        businessPartnerId,
        format,
      );
      saveBlobResponse(response, `elink_bestandsliste.${format}`);
    },
    ...options,
  });
